import Table from "components/Template/Table";
import React from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as Change } from "icons/change-status.svg";
import ButtonIcon from "components/ButtonIcon";
import Eye from "icons/eye.svg";
import Button from "components/Button";

type Props = {
  dataList: any;
  setDataList: React.Dispatch<React.SetStateAction<any[]>>;
  status: string;
  setStatus: React.Dispatch<React.SetStateAction<string>>;
};

const TableGroups: React.FC<Props> = ({
  dataList,
  setDataList,
  status,
  setStatus,
}): JSX.Element => {
  let history = useHistory();

  const orderStatus = () => {
    if (status === "asc") {
      setDataList(
        [...dataList].sort((a: any, b: any) => (a.active > b.active ? 1 : -1))
      );
      setStatus("desc");
    } else {
      setDataList(
        [...dataList].sort((a: any, b: any) => (a.active > b.active ? -1 : 1))
      );
      setStatus("asc");
    }
  };

  return (
    <Table
      childrenThead={
        <tr className="font-sora">
          <td className="px-7">Child name</td>
          <td>Payment email</td>
          <td>
            <div className="flex flex-row">
              Status
              <button className="ml-2" onClick={orderStatus}>
                <Change />
              </button>
            </div>
          </td>
          <td>Reports</td>
          <td className="px-4">View</td>
        </tr>
      }
      childrenTbody={
        <>
          {dataList.length > 0 &&
            dataList.map((data: any, i: number) => (
              <tr className="font-sora" key={i}>
                <td className="px-7 py-7">{data.name ? data.name : ""}</td>
                <td>
                  {data.billingInformation ? data.billingInformation.email : ""}
                </td>
                <td>
                  <div
                    className={`flex flex-col mt-1 text-bt-white justify-center items-center h-12 w-20 rounded-full ${
                      data.active ? "bg-bt-light-green" : "bg-bt-gray-400"
                    }`}
                  >
                    {data.active ? "Active" : "Disabled"}
                  </div>
                </td>
                <td className="w-[70px] relative">
                  {data.reports && (
                    <Button
                      className="font-nunito absolute inset-0 left-[21px] text-white rounded-full border-none w-7 h-7 items-center bg-bt-red-alert"
                      onClick={() => {}}
                      label="!"
                    />
                  )}
                </td>
                <td className="w-[70px] pl-4 pr-4">
                  <ButtonIcon
                    icon={Eye}
                    onClick={() => {
                      if (!data.name) {
                        history.push("/add-new-family", {
                          step: 2,
                          groupId: data._id,
                        });
                      } else {
                        history.push(`/manage-families/${data._id}/details`);
                      }
                    }}
                    status={true}
                  />
                </td>
              </tr>
            ))}
        </>
      }
    />
  );
};

export default TableGroups;
